module.exports = __webpack_public_path__ + "img/ecommerce.c6286205.svg";